(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('DocenteController', DocenteController);

    DocenteController.$inject = ['$scope', '$state', 'Docente', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','AniosEscolares','NivelesEducativosService','ModelosEducativosService','MisInstituciones','Periodos'];

    function DocenteController ($scope, $state, Docente, ParseLinks, AlertService, pagingParams, paginationConstants,AniosEscolares,NivelesEducativosService,ModelosEducativosService,MisInstituciones,Periodos) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSeleccionada = pagingParams.centro;
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        cargarDropdrown();
        loadAll();
        vm.limpiar = limpiar;
        vm.msjCerrado=false;
		
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSeleccionada","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSeleccionada != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSeleccionada,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });

        function loadAll () {
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSeleccionada != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSeleccionada,
            		ic: vm.intercurso
                });
        	}
        	
        	Docente.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            }, onSuccess, onError);
		}
		
        function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
        }
        
		function onSuccess(data, headers) {
			console.log(data);
        	vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            //alert(data);
            vm.clases = data;
             vm.page = pagingParams.page;
        }
		
		/*
		function onSuccess(data, headers) {
		    vm.links = ParseLinks.parse(headers('link'));
		    vm.totalItems = headers('X-Total-Count');
		    vm.queryCount = vm.totalItems;
		    vm.usuarios = data;
		    vm.page = pagingParams.page;
			vm.msjCerrado=true;
		}
		*/
		
        function onError(error) {
        	AlertService.error(error.data.message);
            vm.msjCerrado=false;
        }
		
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                anio: vm.anioSeleccionado,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            });
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=MisInstituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }

        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;

        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
//                type: vm.type,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            },onSuccess, onError);
		}
        
    }
})();
